import React from "react";

const EditButton = ({ title, onClick }) => (
    <button onClick={onClick} className="mdl-button mdl-button--fab fab-mini">
        <i className="material-icons text-success">edit</i> {title}
    </button>
);

export default EditButton;
